import styled from 'styled-components'
import Browser from './../../../services/Browser'
import { breakpoints } from './../../../constants/breakpoits.constants'
import {
	LIGHTGRAY,
	LIGHTERGRAY,
	PRIMARY_LIGHT,
	PRIMARY_COLOR,
	STRONGORANGE,
	BLUE,
	WHITE,
} from '../../../styles/colors.style'

export const StyledContainer = styled.div`
	border: 1px solid ${LIGHTGRAY};
	border-bottom: 3px solid ${LIGHTGRAY};
	border-radius: 5px;
	display: flex;
	flex-wrap: ${Browser.isInternetExplorer() ? 'nowrap' : 'wrap'};
	justify-content: space-between;
	padding: 5px;
	margin-bottom: 10px;
	width: 100%;

	&.trip-option-Leito,
	&.trip-option-LEITO {
		border: 3px solid ${PRIMARY_COLOR};
		border-bottom: 5px solid ${PRIMARY_COLOR};
		flex-wrap: ${Browser.isInternetExplorer() ? 'nowrap' : 'wrap'};
	}

	&:hover {
		background-color: ${LIGHTERGRAY};
		cursor: pointer;
	}

	.fa-icon {
		margin-right: 0.2em;
	}

	.box-assinante {
		flex: 1 1 95%;
	}

	@media screen and (max-width: ${breakpoints.PHONE_LARGE}px) {
		align-items: center;
		flex-direction: column;
	}
`

export const StyledDeparture = styled.div`
	.row-image {
		display: flex;
		margin-left: 15px;
		div {
			max-height: 29px;
		}

		img {
			max-width: 100%;
			margin-right: 5px;
			@media screen and (max-width: ${breakpoints.PHONE_LARGE}px) {
				align-self: center;
			}
		}

		@media screen and (max-width: ${breakpoints.PHONE_LARGE}px) {
			.partner-logo {
				max-width: 125px;
				margin-top: 3px;
			}
		}

		.bus-seats {
			font-weight: 600;
			span {
				float: right;
				margin-top: 5px;
			}
			@media screen and (max-width: ${breakpoints.PHONE_LARGE}px) {
				span {
					max-width: 65px;
					line-height: 14px;
					text-align: center;
					margin-top: 0px;
					font-size: 1.8rem;
				}
			}
		}
		.bus-seats-normal {
			color: #666;
		}

		.bus-seats-on-fire {
			border-radius: 50px;
			padding-right: 6px;
			background-color: ${STRONGORANGE};
			color: #fff;
		}
	}

	.row-destination {
		text-align: left;
		width: 100%;

		@media screen and (max-width: ${breakpoints.PHONE_LARGE}px) {
			margin-top: 10px;
			.row-destination-container {
				padding: 0 15px;
			}
		}

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			padding-left: 15px;
			margin-top: 10px;
		}

		img {
			width: 120px;
			height: auto;
			display: block;
			margin-left: auto;
			margin-right: auto;
		}

		.box-time {
			display: flex;
			justify-content: space-between;

			@media screen and (min-width: ${breakpoints.MOBILE}px) {
				margin: 0 0 10px;
			}
			.departure,
			.duration {
				margin-right: 20px;
			}

			.duration {
				padding: 3px 1.5px 0 1.5px;
				text-align: center;

				.bus-class-no-bus-change {
					color: #f88000;
					font-weight: bold;
				}

				.bus-class {
					font-weight: 600;
				}

				cite {
					em {
						display: block;
						font-size: 11px;
						font-style: normal;
						text-align: center;
						color: #666;
						.fa {
						}
					}
					small {
						color: #666;
						font-style: normal;
					}
				}
				.duration-tooltip {
					max-width: 200px;
					text-align: center;
				}

				.about-time-message {
					font-weight: bold;
					font-size: 6pt;
					@media screen and (min-width: ${breakpoints.MOBILE}px) {
						font-size: 8pt;
					}
				}
			}

			.time {
				font-size: 28px;
				margin: 0;
				text-align: center;
				font-weight: 600;
				line-height: 30px;
			}
			.time + small {
				display: block;
				font-size: 12px;
				color: #666;
				text-align: center;
			}
		}
	}

	.icons-tooltip {
		max-width: 300px;
		padding-left: 0px;
		font-family: 'Source Sans Pro', sans-serif;
		border-radius: 5px;
		background: ${WHITE} !important;
		background-color: ${WHITE} !important;

		p {
			margin: 3px 15px;
			color: #000000;
			font-size: 1.5rem;
		}

		.tooltip-title {
			padding: 4px;
			max-width: 80%;
			font-size: 1.8rem;
			border-top-right-radius: 50px;
			border-bottom-right-radius: 50px;
			font-weight: bold;
			margin-left: 0px;
			line-height: 26px;
			div {
				img {
					max-width: 100% !important;
					margin-bottom: 0px !important;
					margin-right: 0px !important;
					float: left;
					margin-left: 5px;
				}
			}
		}
		.tooltip-title-digital-ticket {
			background: ${BLUE};
			margin-top: 8px;
		}

		.tooltip-title-enhanced-security {
			margin-top: 12px;
			background: ${PRIMARY_LIGHT};
		}
	}
`

export const StyledLogo = styled.img`
	max-width: 100%;
	margin-bottom: 5px;

	@media screen and (max-width: ${breakpoints.PHONE_LARGE}px) {
		align-self: center;
		height: 25%;
		max-width: 50%;
		margin-bottom: 0;
	}
`

export const StyleViagens = styled.ul`
	ul {
		list-style: none;
		padding: 0px;
	}
	li {
		position: relative;
		padding: 10px;
	}
	li a {
		color: gray;
	}
	li:before {
		content: '';
		width: 16px;
		height: 16px;
		border-radius: 50%;
		background: ${PRIMARY_COLOR};
		position: absolute;
		left: -15px;
		top: 50%;
		transform: translateY(-40%);
	}

	li:not(:last-child):after {
		content: '';
		width: 2px;
		height: 100%;
		background: ${PRIMARY_COLOR};
		position: absolute;
		left: -8px;
		top: 50%;
	}
`

export const StyledPricesContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	margin-top: 15px;
	font-size: 1.8rem;

	& > :hover {
		background-color: ${LIGHTERGRAY};
	}

	.prices-container {
		margin-top: 30px;
		display: flex;
		flex: 1;
		flex-direction: column;
		@media screen and (max-width: ${breakpoints.PHONE_LARGE}px) {
			margin-top: 0;
		}
	}
	.with-promotion {
		border: 1px solid rgba(246, 164, 31, 0.5);
		border-radius: 30px 30px 8px 8px;
		border-top-color: transparent;
	}
	.prices-header {
		//background-color: ${WHITE};
		border-top-right-radius: 8px;
		border-top-left-radius: 8px;
		font-size: 1.4rem;
		text-align: center;
		padding-bottom: 3px;
		@media screen and (max-width: ${breakpoints.PHONE_LARGE}px) {
			padding-bottom: 0;
			font-size: 2rem;
		}
	}

	.prices-footer {
		font-size: 1.2rem;
		//background-color: ${WHITE};
		border-bottom-right-radius: 8px;
		border-bottom-left-radius: 8px;
		@media screen and (max-width: ${breakpoints.PHONE_LARGE}px) {
			font-size: 1.5rem;
		}

		.payment-info {
			color: ${BLUE};
			font-weight: bold;
		}

		.sale-info {
			font-weight: normal;
			float: right;
			margin-right: 5px;
			span {
				color: ${STRONGORANGE};
				font-weight: bold;
			}
		}
	}

	.logo {
		height: 23px;
		transform: scale(0.22);
	}
	.upgradeBusClass {
		font-size: 2.5rem;
		width: 100%;
		text-align: center;
		margin-top: 15px;
		margin-bottom: 5px;
	}

	.row {
		display: flex;
		flex-direction: column;
		justify-content: space-evenly;
		padding: 5px;

		@media screen and (max-width: ${breakpoints.PHONE_LARGE}px) {
			margin-bottom: 0px;
		}
	}

	.price-buttons {
		display: flex;
		flex-direction: row-reverse;
		justify-content: space-around;

		> div {
			margin: 0px 2px;
		}
	}

	.price-card-column {
		margin-top: 5px;
		align-items: center;
		display: flex;
		flex-direction: column;
		height: 12em;
		justify-content: space-around;
		width: 100%;
		${Browser.isFirefox()
			? '&.ff-fix-first-child { margin-bottom: 11px; }'
			: ''}
	}

	.subscriber-status {
		align-items: center;
		display: flex;
		flex-direction: column;
		font-size: large;
		justify-content: center;
		margin-right: 5px;
		padding-top: ${Browser.isInternetExplorer() ? '10%' : '5px'};
	}

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		margin-bottom: 0px;
		margin-top: 0px;
		max-width: 440px;

		.upgradeBusClass {
			font-size: 1.8rem;
		}

		.row {
			flex-direction: row;
			border-radius: 5px;
			height: 4em;
			margin-bottom: 0;
			margin-right: 5px;
			height: 100px;

			${Browser.isFirefox()
				? '&.ff-fix-first-child { margin-bottom: 11px; }'
				: ''};
		}

		.subscriber-status {
			font-size: inherit;
			width: 70px;
		}

		.price-card-column {
			flex-direction: row;
			height: ${Browser.isInternetExplorer() ? '1em' : '3em'};
		}
	}

	@media screen and (max-width: ${breakpoints.PHONE_LARGE}px) {
		width: 100%;

		.price-card-column {
			margin-top: initial;
			display: flex;
			flex-direction: column;
			height: inherit;
			width: 100%;

			${Browser.isFirefox()
				? '&.ff-fix-first-child { margin-bottom: 11px; }'
				: ''}
		}

		.row {
			align-items: center;
			align-self: center;
			flex-direction: row;
			padding: 0;
			width: 99%;
		}

		.row-upgrade-modal-true {
			width: 100%;
		}

		.price-buttons {
			display: flex;
			flex-direction: row-reverse;
			width: 95%;
			padding-left: 0px;
			padding-bottom: 10px;
		}

		.buttons-Leito {
			width: 98%;
			padding-left: 5px;
		}
	}

	@media screen and (max-width: ${breakpoints.PHONE_LARGE}px) {
		.price-buttons {
			width: 98%;
			padding: 0;
			margin-left: auto;
			margin-right: auto;
			flex-direction: row-reverse;
		}
	}

	@media screen and (min-width: ${breakpoints.NOTEBOOK}px) {
		.subscriber-status {
			font-size: small;
			width: 120px;
			margin-bottom: 10px;
		}
	}
`

export const StyledButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;

	button {
		padding: 15px 0 0 0;
	}
`
export const StyledBannerContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	margin-top: 15px;
	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		min-width: 400px;
	}
	.message {
		font-size: large;
		margin-bottom: 7px;
	}

	.upgrade-image {
		max-width: 100%;
		display: block;
		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			width: 100%;
		}
	}
`
export const StyledPromotionUserMessage = styled.div`
	color: ${PRIMARY_COLOR};
	font-weight: 600;
	font-family: inherit;
	font-size: 1.8rem;
	padding: 10px 0 0 0;
	text-align: center;
	max-width: 350px;
`

export const StyledBusPromotionMessage = styled.div`
	color: #ffffff;
	background: ${PRIMARY_LIGHT};
	font-size: 1.8rem;
	font-weight: bold;
	text-align: center;
	border-top-right-radius: 25px;
	border-top-left-radius: 25px;
	height: 25px;
	line-height: 25px;

	.promotionpercent-tooltip {
		max-width: 200px;
		text-align: center;
	}
`

export const StyledDestination = styled.div`
	display: flex;
	justify-content: inherit;
	width: 100%;
	flex-direction: column;
	align-items: center;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		flex-direction: row;
	}
`

export const StyledBoxDestination = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	flex-direction: column;
	margin: 0 auto;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		flex-direction: row;
		width: 100%;
		margin: 0;
	}
`
